// extracted by mini-css-extract-plugin
export default {"selectMenu":"SelectMenu_selectMenu__dtL24"};